import { Api } from "@mcleod/core";
import { Snackbar, Toast } from "@mcleod/components";

export class BreakthroughFuelUtility {
    /**
     * Handles the download of Breakthrough Fuel transactions and provides user feedback.
     * @param buttonDownload The button to show busy state.
     * @param refreshTabsCallback Callback to refresh tabs after download.
     */
    static async downloadBreakthroughFuelTransactions(buttonDownload: any, refreshTabsCallback?: () => void) {
        buttonDownload.busy = true;
        const response = await Api.post("lme/ar/download-breakthrough-fuel-transactions");
        buttonDownload.busy = false;

        // If response is empty, show a snackbar message that no transactions were found.
        if (!response || response.data.length === 0) {
            Snackbar.showSnackbar("No Breakthrough Fuel transactions are available to download.");
            return;
        }

        // Check if response contains an error message.
        const errorMsg = response?.data?.[0]?.error;
        if (errorMsg) {
            // If there is an error message, show a snackbar with the error.
            Snackbar.showSnackbar(`Error downloading transactions: ${errorMsg}`);
            return;
        }

        const transCount = response?.data?.[0]?.trans_count;
        if (transCount) {
            // If response is not empty, show a toast message of the number of transactions downloaded.
            Toast.showSuccessToast(`Successfully Downloaded ${transCount} Breakthrough Fuel transaction(s).`);
        }

        // Refresh the table to reflect the changes.
        if (refreshTabsCallback) {
            refreshTabsCallback();
        }
    }
}
